var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-loading",class:[{ 't-loading--centered': _vm.centered }]},[_c(_vm.image,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }